import React, { Component } from 'react';
import withAppLayout from '../components/appLayout';
import { Api } from '../api';
import withCompareWidget from '../components/common/compareWidgetHOC';
// import Modal from '../components/modal';
import { COMPONENT_MAP } from '../constants/homeConstantsNew';
import { handleAmcPage } from '../utils/index';
// import WhyCleartax from '../components/plan/whyCleratax';
import Observer from '../components/common/observerHoc';
import BlackBanner from '../components/homePageNew/blackBanner';
import Header from '../components/nextHead';
import QrModal from './../../app/components/common/qrModal';
import getConfig from 'next/config';
import {
  algoliaIndex,
  stagingAlgoliaIndex,
} from '../constants/searchConstants';

const { publicRuntimeConfig } = getConfig();
const api = new Api();

interface State {
  selectedFundIndex: number;
  otherAMCList: any;
  topFunds: object | any;
  topfundsLimit: number;
  comparisonObj: Record<string, string>;
  plansActiveState: Record<string, boolean>;
  isInputOpen: boolean;
  showQRModal: boolean;
  clickedHeaderItem: string;
}
class HomeNew extends Component<any, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      topfundsLimit: 5,
      selectedFundIndex: 0,
      comparisonObj: {},
      otherAMCList: [],
      isInputOpen: false,
      showQRModal: false,
      topFunds: [],
      plansActiveState: {
        fundsCategory: false,
        topPlans: false,
        fundHouses: false,
        learnMutualFunds: false,
        nfo: false,
      },
      clickedHeaderItem: '',
    };
  }

  private searchFund = async (
    fundType: string,
    categoryType?: string
    // index?: number
  ) => {
    const searchFilters = [
      'purchaseMode:DIRECT',
      'enabled:true',
      `fundType:${fundType}`,
    ];
    if (categoryType) {
      searchFilters.push(`categoryFilter.categoryFilterValue:${categoryType}`);
    }
    const index =
      publicRuntimeConfig.env === 'development' ||
      publicRuntimeConfig.env === 'qa'
        ? stagingAlgoliaIndex
        : algoliaIndex;
    const searchResults = await api.searchFund('', 0, searchFilters, index);
    const data = searchResults.hits.map((ele) => ({
      fundMetaData: {
        slug: ele && ele.fundMetaData && ele.fundMetaData.slug,
        parentSlug: ele && ele.fundMetaData && ele.fundMetaData.parentSlug,
        isinCode: ele && ele.fundMetaData && ele.fundMetaData.isinCode,
      },
      title: ele.fundName,
      subTitle: ele.category,
      nav: ele.currentNav || 'NA',
      imageUrl: ele.imageUrl,
      exitLoad: ele.exitLoad ? `${ele.exitLoad}%` : '-',
      planType: ele.planType,
      return5yr:
        ele &&
        ele.fundMetaData &&
        ele.fundMetaData.returns &&
        ele.fundMetaData.returns.return5yr,
      risk: ele && ele.fundMetaData && ele.fundMetaData.risk,
    }));
    this.setState({ topFunds: data });
  };

  public componentDidMount() {
    this.callAmcList();
    this.searchFund('Equity', '', 0);
  }

  private callAmcList() {
    handleAmcPage(api).then((response: any) => {
      let otherAMCRes = response['amcs'];
      otherAMCRes = otherAMCRes.slice(0, 12);
      this.setState({
        otherAMCList: otherAMCRes,
      });
    });
  }
  // private async sendBlackSMS(phone: string) {
  //   const returnVal = await api.sendBlackSMS(phone);
  //   await api.recordBlackSMSSheet(phone);
  //   return returnVal;
  // }
  private dismiss = () => {
    this.setState({
      showQRModal: false,
    });
  };

  public openQRmodal = () => {
    this.setState({
      showQRModal: true,
    });
  };

  public insideView = (identifier: any, inView: any, clicked?: boolean) => {
    if (
      inView &&
      ((clicked &&
        (!this.state.clickedHeaderItem ||
          this.state.clickedHeaderItem !== identifier)) ||
        (!clicked && !this.state.clickedHeaderItem))
    ) {
      if (!this.state.plansActiveState[identifier]) {
        const obj = { ...this.state.plansActiveState };
        Object.keys(obj).forEach((ele) => {
          ele === identifier ? (obj[ele] = true) : (obj[ele] = false);
        });
        if (clicked) {
          this.setState({
            plansActiveState: { ...obj },
            clickedHeaderItem: identifier,
          });
        } else {
          this.setState({
            plansActiveState: { ...obj },
            clickedHeaderItem: '',
          });
        }
      }
    }
  };

  public outsideView = (identifier: any, inView: any, movingUp: boolean) => {
    if (!inView) {
      if (identifier === 'learnMutualFunds' && !movingUp) {
        const obj = { ...this.state.plansActiveState };
        if (obj[identifier] !== false) {
          this.setState({
            plansActiveState: { ...obj, [identifier]: false },
          });
        }
      }
      if (this.state.clickedHeaderItem === identifier) {
        this.setState({
          clickedHeaderItem: '',
        });
      }
    }
  };

  public render() {
    return (
      <div>
        <Header
          canonicalUrl="https://cleartax.in/mutual-funds"
          description="A mutual fund is formed when an AMC pools investments from several investors to purchase securities such as stocks and bonds. ClearTax Invest helps you to Invest in the best performing mutual funds in 2022 & let your money grow through the power of compounding. We also provide useful guides to help you invest in Mutual Funds!"
          title={
            'Mutual Funds - Invest in Mutual Funds Online India | ClearTax'
          }
        />
        {COMPONENT_MAP.map((ele) => {
          const Section: any = ele.component;
          const fnProps = {};
          const stateProps = {};
          if (ele.fnProps && ele.fnProps.length) {
            ele.fnProps.forEach((innerEle) => {
              fnProps[innerEle] = this[innerEle];
            });
          }
          if (ele.stateProps && ele.stateProps.length) {
            ele.stateProps.forEach((innerEle) => {
              stateProps[innerEle] = this.state[innerEle];
            });
          }
          if (ele.identifier === 'BlackBanner') {
            return <BlackBanner openQRModal={() => this.openQRmodal()} />;
          }
          if (ele.observerId) {
            return (
              <Observer
                isActive={this.state.plansActiveState[ele.observerId]}
                identifier={ele.observerId}
                insideView={this.insideView}
                outsideView={this.outsideView}
                threshold={this.props.isMobile ? 0.2 : 0.5}
                render={() => (
                  <Section
                    {...ele.props}
                    {...fnProps}
                    {...stateProps}
                    isMobile={this.props.isMobile}
                  />
                )}
              />
            );
          }
          return (
            <Section
              {...ele.props}
              {...fnProps}
              {...stateProps}
              isMobile={this.props.isMobile}
            />
          );
        })}
        {this.state.showQRModal ? <QrModal onDismiss={this.dismiss} /> : null}
      </div>
    );
  }
}

export default withAppLayout(
  {
    title: 'CleartaxInvest:Home',
    hideDefaultCanonical: true,
  },
  withCompareWidget(HomeNew)
);



// WEBPACK FOOTER //
// ./pages/mfHome.tsx